/**
 * Provides styled components for lists.
 */
import { FlatList, StyleSheet, View, TouchableOpacity, TextStyle, TextProps } from 'react-native';
import { typography, TypographyProps, color, ColorProps } from 'styled-system';
import styled from 'styled-components/native';

import { Colors } from 'theme/colors';
import { FontFamily, FontSize, FontWeight } from 'theme/fonts';

export const ListContainer = styled(View)`
  height: 135;
  border-top-width: ${StyleSheet.hairlineWidth};
  border-top-color: ${Colors.lightGrey};
  padding-top: 5;
  padding-horizontal: 5;
  background-color: ${Colors.lightGrey};
`;

export const List = (styled(FlatList)`
  flex: 1;
  background-color: ${Colors.white};
  border-radius: 5;
` as React.ComponentType) as new <T>() => FlatList<T>;

export const ListItem = styled(TouchableOpacity)`
  flex: 1;
  color: ${Colors.black};
  background-color: ${Colors.white};
  border-bottom-width: ${StyleSheet.hairlineWidth};
  border-bottom-color: ${Colors.lightGrey};
  padding-vertical: 15;
  padding-horizontal: 15;
  flex-direction: row;
`;

export const ListItemText = styled.Text<TypographyProps & ColorProps>`
  color: ${Colors.black};
  font-size: ${FontSize.Regular};
  font-family: ${FontFamily.Light};
  font-weight: ${FontWeight.Regular};
  ${typography}
  ${color}
`;
